module.exports = __webpack_public_path__ + "JithinPeter-de6146bc.webp";